import Loading from '../../../../components/Loading';
import useProjects from '../../../../hooks/useProjects';
import ProjectsDataGrid from './ProjectsDataGrid';

/**
 * This component displays all projects in a data grid
 * @returns Projects Data Grid
 */
function AllProjects() {
  const { data: projects, isLoading: isLoadingProjects } = useProjects();

  if (isLoadingProjects) {
    return <Loading />;
  }

  return <ProjectsDataGrid projects={projects} />;
}

export default AllProjects;
